import React from 'react';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import QRCode from 'qrcode.react';
import { getDayWithMonth, getDayOfTheWeek, getMomentOfSession } from '../utils';

const FilmCard = ({
  serverTime,
  currentTime,
  age,
  duration,
  genre,
  poster,
  url,
  sessions,
  premiere,
}) => {
  const currentDay = moment(serverTime).format('DD.MM.YYYY');

  /* Получаем дату для фильма вместе с днём недели  */
  const getFilmDate = (date) => {
    const tomorrow = moment(serverTime)
      .add(1, 'days')
      .format('DD.MM.YYYY');

    if (currentDay === date) {
      return `Сегодня ${getDayWithMonth(date)}`;
    }

    if (tomorrow === date) {
      return `Завтра ${getDayWithMonth(date)}`;
    }

    return `${getDayOfTheWeek(date)} ${getDayWithMonth(date)}`;
  };

  /* Выводим сеансы */
  const renderSessions = () => {
    /* Получаем дату сеанса */
    const sessionDate = Object.keys(sessions)[0];

    /* Нет сеансов - ничего не выводим */
    if (sessions[sessionDate] === undefined) {
      return [];
    }

    const values = sessions[sessionDate].map((session) => {
      /* Получаем момент сеанса */
      const momentSessionTime = getMomentOfSession(sessionDate, session.time);
      /* Момент времени с сервера */
      const momentServerTime = moment(currentTime, 'X');
      /* Определяем разницу между временем сервера и сеанса */
      const timeDifference = momentServerTime.diff(
        momentSessionTime,
        'minutes',
      );

      /* Если сеанс начался и длится не более 30 минут – статус Disabled */
      const isDisabled = timeDifference >= 0 && timeDifference <= 30;
      /* Если прошло более 30 минут – статус Deleted */
      const isDeleted = timeDifference >= 30;

      if (!isDeleted) {
        return (
          <li
            key={session.id}
            className={`timetable__item timetable__item--${
              session.format
            } timetable__item--lg ${isDisabled && 'timetable__item--disabled'}`}
          >
            <div className="a">
              <span>{session.time}</span>
              {session.price_min === session.price_max ? (
                <span className="price">{`${session.price} ₽`}</span>
              ) : (
                <span className="price">{`от ${session.price_min} ₽`}</span>
              )}
            </div>
          </li>
        );
      }

      return null;
    });

    /* Фильтруем полученный результат и возвращаем из него 5 элементов */
    return values.filter((item) => item).slice(0, 5);
  };

  /* Генерируем ссылку из домена и до страницы фильма */
  const getQRCodeLink = () => window.location.origin + url;

  return (
    <div className="film-card">
      <div
        className="film-card__poster"
        style={{ backgroundImage: `url(${poster})` }}
      >
        <div className="film-card__qr">
          <QRCode value={getQRCodeLink()} size={148} />
          <span>Подробнее на сайте</span>
        </div>
      </div>
      <div className="film-card__info">
        <div className="film-card__details">
          <p>
            <span>{genre}</span> · {duration}
          </p>
          {!premiere && (
            <p className="film-card__date">
              {getFilmDate(Object.keys(sessions)[0])}
            </p>
          )}
        </div>
        <span className="film-card__age">{age}</span>
      </div>
      {premiere ? (
        <p className="film-card__premiere">
          Премьера
          <span> {getDayWithMonth(premiere)}</span>
        </p>
      ) : (
        <ul className="film-card__sessions">{renderSessions()}</ul>
      )}
    </div>
  );
};

FilmCard.propTypes = {
  serverTime: PropTypes.string.isRequired,
  currentTime: PropTypes.number.isRequired,
  age: PropTypes.string.isRequired,
  duration: PropTypes.string.isRequired,
  genre: PropTypes.string.isRequired,
  poster: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  sessions: PropTypes.object,
  premiere: PropTypes.string,
};

FilmCard.defaultProps = {
  sessions: {},
  premiere: null,
};

export default FilmCard;
